import { render, staticRenderFns } from "./reservation-message-info.vue?vue&type=template&id=a8d53180&"
import script from "./reservation-message-info.vue?vue&type=script&lang=js&"
export * from "./reservation-message-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports